import React from 'react';
import { styled } from '@glitz/react';
import { SolidButton, ButtonTheme } from 'Shared/TextButtons';
import ArticleListViewModel from 'MagazineStart/ArticleListViewModel.type';

const MobileButtonWrap = styled.div({
  display: 'flex',
  whiteSpace: 'nowrap',
})

const MobileButton = styled(SolidButton, {
  scrollSnapAlign: 'center',
  pointerEvents: 'auto',
  userSelect: 'none',
  touchAction: 'auto',
})

const TagButtons = (props: {
  selectedTag: string;
  articleListViewModel: ArticleListViewModel;
  isCompact: boolean;
  onFilterClick: (number?: number, tag?: string) => void;
}) => {
  const { articleListViewModel, selectedTag, isCompact, onFilterClick } = props;
  
  if(isCompact) {
    return (
      <>
        {articleListViewModel.filterTags.map((filterTag, index, array) => (
          <MobileButtonWrap key={index}>
            <MobileButton
              text={filterTag}
              key={index}
              theme={ButtonTheme.WhiteToBlack}
              selected={filterTag.toLowerCase() === selectedTag?.toLowerCase() || (!array.includes(selectedTag) && index === 0)}
              onClick={() => onFilterClick(null, filterTag)}
            />
          </MobileButtonWrap>
        ))}
      </>
    );  
  }
  
  return (
    <>
      {articleListViewModel.filterTags.map((filterTag, index, array) => (
        <SolidButton
          text={filterTag}
          key={index}
          theme={ButtonTheme.WhiteToBlack}
          selected={filterTag.toLowerCase() === selectedTag?.toLowerCase() || (!array.includes(selectedTag) && index === 0)}
          onClick={() => onFilterClick(null, filterTag)}
        />
      ))}
    </>
  );
};

export default TagButtons;